module.exports = __webpack_public_path__ + "img/semidark.675e88dd.jpg";